import DataTable from '@/containers/data_table_ml/DataTable';
import './TablePage.less';
import React, { useRef, useCallback, useEffect } from 'react';
import ButtonML from '@/components/button_ml/ButtonML';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import { useDispatch, useSelector } from 'dva';
import { Form, message } from 'antd';
import { hasUndefInObj } from '../../../../../../utils/breUtils';

const HandleTabel = (props) => {
  // const data = useSelector((state) => state.tvfCondition.getTvfRuleList);
  const { name, id, handleClick } = props;
  const dispatch = useDispatch();
  const unitInput = useRef(null);
  // const [tableList, setTableList] = useState([]);
  const [form] = Form.useForm();

  const columns = [
    {
      title: '输入字段',
      dataIndex: 'desc',
      key: 'desc',
      render: (text) => <span>{text}</span>,
    },
    {
      title: '输入值',
      dataIndex: 'operator',
      key: 'operator',
      render: (text, record) => {
        return (
          <SingInputML
            height="37px"
            labelwidth="0px"
            inputWidth="100px"
            placeVal="请输入值"
            className="no_label"
            name={record.name}
            refs={unitInput}
          />
        );
      },
    },
  ];

  const hanleClick = () => {
    const formVal = form.getFieldsValue();
    if (JSON.stringify(formVal) === '{}') {
      message.warning('请添加输入值');
      return;
    }

    if (hasUndefInObj(formVal, undefined) || hasUndefInObj(formVal, '')) {
      message.warning('请填写完整');
      return;
    }
    //查询exp
    dispatch({
      type: 'tvfUnitTest/getTest',
      payload: {
        values: {
          id: id,
          ...formVal,
          // brandId: brandId,
        },
      },
      callback: (d) => {
        if (d.code && d.code !== 0) {
          message.warning(d.message);
        } else if (JSON.stringify(d?.valueMap) === '{}') {
          message.warning('测试完成, 未命中规则');
        } else {
          message.success('测试完成');
        }
        handleClick(d);
      },
    });
  };
  const hanleReset = () => {
    form.resetFields();
  };
  // // 对测试列表进行筛选
  // const fetchData = useCallback(() => {
  //   let obj = {};

  //   (data || []).map((item) => {
  //     // 对多个的外部入参和系统参数进行过滤
  //     if (item.variableType1 === 'SYSTEM') {
  //       obj[item['element1Name']] = item['element1'];
  //     }
  //     if (item.variableType2 === 'SYSTEM') {
  //       obj[item['element2Name']] = item['element2'];
  //     }
  //   });
  //   let arr = [];
  //   for (let key in obj) {
  //     arr.push({ name: key, val: obj[key] });
  //   }
  //   setTableList(arr);
  // }, [data]);

  const fetchData = useCallback(() => {
    dispatch({
      type: 'tvfUnitTest/getUnitTest',
      payload: {
        values: {
          id: id,
          // brandId: brandId,
        },
      },
    });
  }, [dispatch, id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const inputList = useSelector((state) => state.tvfUnitTest.getUnitTest);
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['tvfUnitTest/getUnitTest'];

  return (
    <Form form={form} name="unit">
      <DataTable
        border={true}
        className="demo-test"
        style={{
          minWidth: '1547px',
          minHeight: '400px',
          border: '1px solid #edf0f0',
          marginTop: '1rem',
        }}
        columns={columns}
        rowSelection={false}
        scroll={{ y: 'calc(100vh - 160px - 3rem)' }}
        dataSource={inputList}
        loading={loading}
        title={() => (
          <div className="rule_name">
            <span>临时变量名称</span>
            {name}
          </div>
        )}
        footer={() => (
          <>
            <ButtonML
              size="large"
              value="执行"
              htmlType="submit"
              fontsize="16px"
              onClick={() => hanleClick()}
            />
            <ButtonML
              size="large"
              value="重置"
              htmlType="submit"
              fontsize="16px"
              onClick={() => hanleReset()}
            />
          </>
        )}
      />
    </Form>
  );
};
export default HandleTabel;
